export default __webpack_public_path__ + "assets/front/scss/recherche/astuces/styles.a76f619d9aec7bf3d7304174ba893ae3.css";